var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
    HorizontalAlignment[HorizontalAlignment["Justified"] = 3] = "Justified";
})(HorizontalAlignment || (HorizontalAlignment = {}));
;
var Type;
(function (Type) {
    Type[Type["Select"] = 0] = "Select";
    Type[Type["Where"] = 1] = "Where";
    Type[Type["OrderBy"] = 2] = "OrderBy";
    Type[Type["GroupBy"] = 3] = "GroupBy";
    Type[Type["SelectMany"] = 4] = "SelectMany";
})(Type || (Type = {}));
;
var ReportTypes;
(function (ReportTypes) {
    ReportTypes[ReportTypes["normal"] = 0] = "normal";
    ReportTypes[ReportTypes["boolean"] = 1] = "boolean";
    ReportTypes[ReportTypes["date"] = 2] = "date";
    ReportTypes[ReportTypes["dateTime"] = 3] = "dateTime";
})(ReportTypes || (ReportTypes = {}));
;
class Column {
    constructor(_DataOnly = null, _Name = '', _Description = '', _Value = '', _HorizontalAlignment = HorizontalAlignment.Left) {
        this.DataOnly = _DataOnly;
        this.Name = _Name;
        this.Description = _Description;
        this.Value = _Value;
        this.HorizontalAlignment = _HorizontalAlignment;
    }
}
class Parameters {
    constructor(_Name = '', _Value = '') {
        this.Name = _Name;
        this.Value = _Value;
    }
}
class Expression {
    constructor() {
        this.Value = '';
        this.Alias = '';
        this.Columns = [];
        this.ExpressionType = Type.Select;
    }
}
class ReportModel {
    constructor() {
        this.ReportName = '';
        this.commandData = '';
        this.ProcedureName = '';
        this.DataSetPosition = '';
        this.Parameters = [];
        this.MaximumStreamData = null;
        this.Using = [];
        this.Expressions = [];
        this.ShowNumberColumn = false;
    }
}
export { ReportModel, Expression, Column, 
// enums
HorizontalAlignment, Type, ReportTypes, Parameters };
//# sourceMappingURL=ReportModel.js.map